'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'house';
var width = 512;
var height = 512;
var aliases = [127968,63498,63500,"home","home-alt","home-lg-alt"];
var unicode = 'f015';
var svgPathData = 'M256.1-5.9l10.9 10.2 240 224 11.7 10.9-21.8 23.4c-6.2-5.8-17.2-16-32.8-30.6l0 280-416 0 0-280c-15.6 14.6-26.5 24.8-32.8 30.6l-21.8-23.4 11.7-10.9 240-224 10.9-10.2zm0 43.8l-176 164.3 0 277.8 96 0 0-176 160 0 0 176 96 0 0-277.8-176-164.3zM208.1 480l96 0 0-144-96 0 0 144z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faHouse = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;